import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@breath-lab/state';
import { ROUTES } from '../../../routes';
import { logEvent } from '../../../infra/firebase/analytics';
import { AnalyticsEvent } from '../../../domain/analytics';
import styles from './ConfigurabilitySection.module.css';

const SLIDER_MAX = 15;
const VALUE = 4;
const FILL_PCT = `${((VALUE / SLIDER_MAX) * 100).toFixed(1)}%`;

export default function ConfigurabilitySection() {
  const { t } = useTranslation('landing');
  const { openLoginModal, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  function handleStartClick() {
    logEvent(AnalyticsEvent.landingConfigurabilityStartClick);
    if (isAuthenticated) {
      navigate(ROUTES.loggedInHome);
    } else {
      openLoginModal();
    }
  }

  const PHASES = [
    t('configurability.phases.inhale'),
    t('configurability.phases.holdFull'),
    t('configurability.phases.exhale'),
    t('configurability.phases.holdEmpty'),
  ];

  return (
    <section className={styles.section}>
      <div className={styles.inner}>

        <div className={styles.text}>
          <p className={styles.eyebrow}>{t('configurability.eyebrow')}</p>
          <h2 className={styles.heading}>{t('configurability.heading')}</h2>
          <p className={styles.body}>
            {t('configurability.body')}
          </p>
        </div>

        <div className={styles.mockup}>
          <div className={styles.mockupHeader} aria-hidden="true">
            <p className={styles.mockupTitle}>{t('configurability.mockupTitle')}</p>
            <p className={styles.mockupSubtitle}>{t('configurability.mockupSubtitle')}</p>
          </div>

          <div className={styles.block} aria-hidden="true">
            <p className={styles.blockLabel}>{t('configurability.sessionLabel')}</p>
            <div className={styles.stepperRow}>
              <span className={styles.rowLabel}>{t('configurability.rounds')}</span>
              <div className={styles.stepper}>
                <span className={styles.stepBtn}>−</span>
                <span className={styles.stepVal}>8</span>
                <span className={`${styles.stepBtn} ${styles.stepBtnActive}`}>+</span>
              </div>
            </div>
          </div>

          <div className={styles.block} aria-hidden="true">
            <p className={styles.blockLabel}>{t('configurability.breathDurationLabel')}</p>
            {PHASES.map((phase) => (
              <div key={phase} className={styles.sliderRow}>
                <div className={styles.sliderMeta}>
                  <span className={styles.rowLabel}>{phase}</span>
                  <span className={styles.sliderVal}>{VALUE}s</span>
                </div>
                <div className={styles.track}>
                  <div className={styles.fill} style={{ width: FILL_PCT }}>
                    <div className={styles.thumb} />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.mockupFooter}>
            <p className={styles.durationText} aria-hidden="true">{t('configurability.estimatedDuration')}</p>
            <button className={styles.startBtn} onClick={handleStartClick}>
              {t('configurability.startSession')}
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}
